import { makeStyles } from "@material-ui/core";

export const useUserListRowStyles = makeStyles((theme) => ({
  limitedText: {
    maxWidth: "80ch",
    overflow: "break-word"
  }
}));
